//export const API_URL = "http://10.2.0.207:5000/";
export const API_URL = "https://api.minifigfinder.com/";

export const STRIPE_PUBLISHABLE_KEY = "pk_live_51JzXopFfKgYY6HYCvbyUzIzFWgMQRlZ8ztY0LwT9KDxzUwYHF0mnkiw7xlrok8P0b9lqp6qQQopGY0fliysL9mOC00Sbiekzzx";
export default {STRIPE_PUBLISHABLE_KEY, API_URL};